import { render, staticRenderFns } from "./TextModule.vue?vue&type=template&id=14b51aca"
import script from "./TextModule.vue?vue&type=script&lang=js"
export * from "./TextModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports